import PropTypes from 'prop-types';

export const simpleIconPropsTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  rounded: PropTypes.bool,
  filled: PropTypes.bool,
};
